const config = {
  /**
   * Helps intellisense give us chart options
   * @type {import("chart.js").ChartData}
   */
  data: {
    labels: ["Wins", "Losses"],
    datasets: [
      {
        type: 'bar',
        data: [],
        backgroundColor: ["rgba(23, 153, 0, 0.8)", "rgba(15, 34, 204, 0.8)"],
        hoverOffset: 4,
      },
    ],
  },
  /**
   * Helps intellisense give us chart options
   * @type {import("chart.js").ChartOptions}
   */
  options: {
    indexAxis: 'y',
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        padding: 10,
        boxPadding: 5,
        caretPadding: 15,
      },
      legend: {
        position: "bottom", // Moves legend below the chart
        align: "center", // Ensures the legend is centered
        labels: {
          boxWidth: 20, // Controls the box size next to each label
          padding: 15, // Adds spacing between legend items
          font: {
            size: 14,
            weight: "bold",
          },
          generateLabels: (chart) => {
            const dataset = chart.data.datasets[0];
            return chart.data.labels.map((label, i) => ({
              text: `${label}: ${dataset.data[i]}`, // Show raw value in legend
              fillStyle: dataset.backgroundColor[i],
              strokeStyle: "#fff",
              fontColor: "#666", // Need to set the color because generateLabels resets it
            }));
          },
        },
      },
      datalabels: {
        color: "#fff",
        font: { size: 16, weight: "bold" },
        formatter: (value, context) => {
          let total = context.dataset.data.reduce((acc, curr) => acc + curr, 0);
          let percentage = ((value / total) * 100).toFixed(1) + "%";
          return percentage; // Show as percentages
        },
      },
      title: {
        display: true,
        text: "Win Rate",
        padding: { top: 15, bottom: 15 },
        font: {
          size: 20,
        },
      },
    },
  },
};

export default config;
